import React, { useCallback } from 'react';
import { ScreenWrapper } from '../../components/Wrappers/ScreenWrapper';
import theme, { TMaterialStyles } from '../../theme';
import { useNavigate } from 'react-router';
import { ERoutes } from '../../enums';
import { Box, Grid2 } from '@mui/material';
import { getRandomQuizz } from '../../queries';
import { useTranslation } from 'react-i18next';
import { ContentWrapperWithClose } from '../../components/Wrappers/ContentWrapperWithClose';
import TypogrphyWithShadow from '../../components/Typography/TypographyWithShadow';
import { ButtonOutlined } from '../../components/Buttons/ButtonOutlined';
import { WithQuizzQuard } from '../../components/Guards/WithQuizzGuard';

const QuizzStartScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onBack = useCallback(() => navigate(ERoutes.main), [navigate]);

  const onStartQuizz = useCallback(async () => {
    try {
      await getRandomQuizz();

      navigate(ERoutes.quizz);
    } catch (error: any) {
      console.error('Error while [onStartQuizz]', error);
    }
  }, [navigate]);

  return (
    <WithQuizzQuard>
      <ScreenWrapper onBack={onBack}>
        <Grid2 sx={materialStyles.screenContainer}>
          <ContentWrapperWithClose
            wrapperContainerSx={materialStyles.wrapperContainerSx}
            illustrationName="HippoStart"
            onClose={onBack}
          >
            <TypogrphyWithShadow shadowType="DARK" sx={materialStyles.title}>
              {t('quizz.are_you_ready')}
            </TypogrphyWithShadow>
            <TypogrphyWithShadow shadowType="DARK" sx={materialStyles.subtitle}>
              {t('quizz.quizz_is_about_to_start')}
            </TypogrphyWithShadow>
            <Box sx={materialStyles.buttonsContainer}>
              <ButtonOutlined
                shadowType="DARK"
                sx={materialStyles.button}
                onClick={onBack}
              >
                {t('quizz.quit_quizz')}
              </ButtonOutlined>
              <ButtonOutlined
                shadowType="DARK"
                sx={materialStyles.button}
                onClick={onStartQuizz}
              >
                {t('quizz.start_quizz')}
              </ButtonOutlined>
            </Box>
          </ContentWrapperWithClose>
        </Grid2>
      </ScreenWrapper>
    </WithQuizzQuard>
  );
};

const materialStyles: TMaterialStyles = {
  screenContainer: {
    flex: 1,
    paddingX: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  wrapperContainerSx: {
    px: '16px',
    pb: '16px',
    pt: '55px',
  },
  title: {
    fontSize: '32px',
    lineHeight: '36px',
    fontFamily: 'Rubber Duck !important',
    textShadow: `0px 1.5px 0px ${theme.palette.secondary.main}`,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '16px',
    lineHeight: '18px',
    marginTop: '20px',
    textAlign: 'center',
    fontWeight: '600',
    letterSpacing: '0.1px',
    whiteSpace: 'pre',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    marginTop: '28px',
  },
  button: {
    flex: 1,
  },
};

export default QuizzStartScreen;
